"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _RateButtonModule = _interopRequireDefault(require("./RateButton.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function RateButton(_ref) {
  var _classNames;

  var item = _ref.item,
      _onClick = _ref.onClick;
  var rateClasses = (0, _classnames["default"])((_classNames = {
    btn: true
  }, _defineProperty(_classNames, _RateButtonModule["default"].rate, true), _defineProperty(_classNames, _RateButtonModule["default"].selected, item.selected), _defineProperty(_classNames, _RateButtonModule["default"].first, item.first), _defineProperty(_classNames, _RateButtonModule["default"].last, item.last), _defineProperty(_classNames, _RateButtonModule["default"].border, item.border), _classNames));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rateClasses,
    onClick: function onClick() {
      return _onClick(item);
    }
  }, item.name);
}

RateButton.propTypes = {
  item: _propTypes["default"].object.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
var _default = RateButton;
exports["default"] = _default;